import React from 'react';
import { AnimatedShape, Box, useThemeValue } from '@altermaind/web/ui';
import { convertSizeToNumber } from '@/_shared/helpers/convertSizeToNumber';

export const CardsHeaderContentSkeleton = () => {
  const gapM = convertSizeToNumber(`${useThemeValue('sizes', 'm')}`);

  return (
    <Box
      display='flex'
      mx='none'
      flexDirection='column'
      width='100%'
      zIndex={99}
      justifyContent='space-between'
      height='100%'
    >
      <Box display='flex' flexWrap='wrap' justifyContent='flex-end' style={{ gap: gapM }}>
        {/* RATING (se presenti) */}
        <Box
          display='flex'
          flexDirection='row'
          alignItems='center'
          width='100%'
          justifyContent='flex-end'
        >
          <AnimatedShape height={15} width={15} variant='semiRound' mr='xxs' />
          <AnimatedShape height={15} width={15} variant='semiRound' />
        </Box>
      </Box>
      {/* MAIN INFO CONTENT */}

      <Box display='flex' flexWrap='wrap' justifyContent='flex-start' style={{ gap: gapM }}>
        <Box display='flex' flexDirection='row' alignItems='center' width='100%'>
          <AnimatedShape height={15} width='45%' variant='semiRound' />
        </Box>
      </Box>
    </Box>
  );
};
